import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const NewProjectContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    height: 100vh;
    border-radius: 4px;
  `}
`;
